import { sortBy } from 'lodash';

import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';
import { Querystring } from 'utils/url';
import { snakeCaseKeys } from 'utils/keys';

import type { Action } from 'types';

const LOADING = 'adminSearchDeliverables/LOADING';
const LOADED = 'adminSearchDeliverables/LOADED';
const RESET = 'adminSearchDeliverables/RESET';

const ITEMS_PER_PAGE = 100;

const initialState = {
  isLoading: false,
  list: []
};

function setLoadingStatus(status: boolean): Action {
  return {
    type: LOADING,
    payload: {
      status
    }
  };
}

export function resetDeliverables(): Action {
  return {
    type: RESET
  };
}

function searchResultsLoaded(data): Action {
  return {
    type: LOADED,
    payload: {
      data
    }
  };
}

export function searchDeliverablesWithPosts(
  campaignId: number,
  influencerId: number,
  deliverableType?: string,
  includeAdditional?: boolean
) {
  const queryString = Querystring.objectToString(snakeCaseKeys({
    page: 1,
    itemsPerPage: ITEMS_PER_PAGE,
    sort: 'start_date_asc',
    creatorId: influencerId,
    include: 'post',
    deliverableType,
    includeAdditional
  }));
  const url = `${API.END_POINTS.CAMPAIGNS.getCampaignDeliverables(campaignId)}?${queryString}`;

  return async (dispatch) => {
    dispatch(setLoadingStatus(true));

    try {
      const response = await get(url);
      const filteredResults = response.data.data.filter(deliverable => Boolean(deliverable.post));
      const results = sortBy(filteredResults, 'endDate');
      dispatch(searchResultsLoaded(results));
      dispatch(setLoadingStatus(false));
    } catch (error) {
      dispatch(setLoadingStatus(false));
      throw error;
    }
  };
}

export default createReducer<any, any>('adminSearchDeliverables', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [RESET]: () => initialState,
  [LOADING]: (state, { status }) => ({
    ...state,
    isLoading: status
  }),
  [LOADED]: (state, { data }) => ({
    ...state,
    list: data
  })
});
